import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import travelIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-travel-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import {
  getProductTravelTotal,
  createSystemBoundaryProductTravel,
} from "../../../../../apis/Product/BusinessTravelTotalApi";

const TravelIcon = () => (
  <img src={travelIcon} alt="Travel Icon" width={76} height={76} />
);

const ProdTravelHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");

  useEffect(() => {
    getProductTravelTotal({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
  }, [productId]);
  return (
    <CategoryComponent
      show={show}
      className={`prod-travel-category ${className || ""}`}
      leftBoxProps={{
        icon: <TravelIcon />,
        title: t("BUSINESS_TRAVEL"),
        description: t("BUSINESS_TRAVEL_INTRO"),
        productId: productId,
        isSystemBoundary: true,
        systemBoundary: systemBoundaryItem,
        setSystemBoundary: setSystemBoundaryItem,
        createSystemBoundaryFunc: createSystemBoundaryProductTravel,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalProdItem
                        ? handleToFixedNum(
                            totalProdItem,
                            totalProdItem?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ProdTravelHeader;
